@if (siteName) {
  <div class="public-phone-contact-card border-rad-all-2" data-automation="public-phone-contact-card">
    <div class="public-phone-contact-card__header">
      <span>{{ 'tkey;pages.phone.header' | translate }}</span>
      @if (phoneRegistrationStatus) {
        <span
          class="public-phone-contact-card__header__status-icon"
          data-automation="public-phone-contact-card-registration-status"
        >
          <i
            [ngClass]="phoneRegistrationStatusIconClass"
            [ngbTooltip]="humanReadableRegistrationStatus.get(phoneRegistrationStatus) | translate"
            data-automation="public-phone-contact-card-registration-status-icon"
          ></i>
        </span>
      }
    </div>
    <div class="public-phone-contact-card__body">
      <div data-automation="public-phone-contact-card-description">
        <strong>{{ phoneDescription }}</strong>
      </div>
      <div data-automation="public-phone-contact-card-name">{{ phoneName }}</div>
      <div data-automation="public-phone-contact-card-site">
        <i [class]="ziroIcons.SITE"></i>
        <span class="ms-1">{{ siteName }}</span>
      </div>
    </div>
  </div>
}
